export default __webpack_public_path__ + "static/media/dewali-promo.d92fbc94.webp";